/**
 * Labstep
 *
 * @module core/Text/Helper
 * @desc Helper Text
 */

import { Icon } from 'labstep-web/core/Icon';
import type React from 'react';
import styles from './styles.module.scss';
import type { ITextHelperProps } from './types';

export const TextHelper: React.FC<ITextHelperProps> = ({
  children,
}) => (
  <div className={styles.textHelper}>
    <Icon name="info circle" />
    {children}
  </div>
);
